import DetailPage from './DetailPage';

export default function WorkDetailPage() {
  return (
    <DetailPage
      contentType="work"
      backLink="/"
      relatedLabel="RELATED WORK"
      relatedAspectRatio="aspect-[4/3]"
      showClient
      showLocation
      notFoundRedirect="/"
    />
  );
}
